import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { Utils } from '@src/utils/util';
import { ImpactAnalysisDeploymentComponent} from './impact-analysis-deployment'
import {HttpClientModule} from '@angular/common/http';
import { DbmAdditionalOptionsModule } from '@app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.module';
@NgModule({
    imports: [SharedModule, HttpClientModule , DbmAdditionalOptionsModule ],
    declarations: [ImpactAnalysisDeploymentComponent],
    entryComponents: [ImpactAnalysisDeploymentComponent],
    exports: [ImpactAnalysisDeploymentComponent],
    providers: [ Utils]
})

export class ImpactAnalysisDeploymentModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-deployment-ang7/impact-analysis-deployment.module.ts